import React, { useState } from 'react';
import '../styles/pages/BusinessPrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const BusinessPrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const businessTypes = [
    {
      id: 1,
      title: "Bill Book",
      icon: "📋",
      description: "Professional bill books and invoice pads for your business. Custom printed with your company branding and details.",
      features: [
        "Custom company branding",
        "Multiple page options",
        "Carbonless paper",
        "Sequential numbering",
        "Professional layout",
        "Bulk printing discounts"
      ],
      specifications: {
        material: "Carbonless paper, 80 GSM",
        thickness: "80 GSM",
        width: "A4, A5, custom sizes",
        durability: "Standard paper quality",
        applications: "Invoices, receipts, bills"
      },
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&h=350&fit=crop",
      color: "#3b82f6",
      bestFor: ["Retail stores", "Service businesses", "Restaurants", "Small businesses"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Seal & Stamp",
      icon: "🪧",
      description: "Custom company seals and rubber stamps for official documentation. High-quality embossing and printing services.",
      features: [
        "Custom seal designs",
        "Rubber stamp creation",
        "Embossing options",
        "Various sizes",
        "Quick production",
        "Professional quality"
      ],
      specifications: {
        material: "Rubber, metal embossing",
        thickness: "Varies by type",
        width: "Custom sizes",
        durability: "Long-lasting",
        applications: "Official documents, certificates"
      },
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=500&h=350&fit=crop",
      color: "#ef4444",
      bestFor: ["Corporate offices", "Legal firms", "Government agencies", "Educational institutions"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "Sticker",
      icon: "🏷️",
      description: "Custom stickers for branding, labeling, and marketing. Waterproof and durable options for various applications.",
      features: [
        "Custom shapes and sizes",
        "Waterproof vinyl",
        "Die-cut options",
        "Bulk quantities",
        "High-resolution printing",
        "Various finishes"
      ],
      specifications: {
        material: "Vinyl, paper stickers",
        thickness: "Varies by type",
        width: "Custom sizes",
        durability: "Waterproof, UV resistant",
        applications: "Product labeling, branding"
      },
      image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=500&h=350&fit=crop",
      color: "#10b981",
      bestFor: ["Product packaging", "Branding campaigns", "Event promotion", "Retail labeling"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="business-printing-page">
      <HeroSection
        heroTitle="Business Printing Services"
        heroSubtitle="Professional printing solutions for your business needs. From bill books to custom stamps, we provide quality printing that enhances your brand."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection
        flexTypes={businessTypes}
        title="Our Premium Business Printing Solutions"
        subtitle="Professional printing solutions for your business needs. From bill books to custom stamps, we provide quality printing that enhances your brand."
      />

      <FlexPortfolio
        activeSection={activeSection}
        portfolioData={businessTypes.map(businessType => ({
          id: businessType.id,
          title: businessType.title,
          icon: businessType.icon,
          gallery: businessType.portfolio?.gallery || []
        }))}
        title="Our Business Printing Portfolio"
        subtitle="Explore our premium business printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default BusinessPrinting;
